import { upsertResourceFilterGroup } from '@dispatch/shared/services';
import { ResourceFilterGroup } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertResourceFilterGroup = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-filter-group', userId],
    (data: ResourceFilterGroup) =>
      upsertResourceFilterGroup(
        {
          ...data,
          userId,
        },
        userId
      ),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertTaskFilterGroup: mutate,
    upsertTaskFilterGroupError: error,
    upsertTaskFilterGroupStatus: status,
  };
};
